"use strict";
/**
 * Shared keyboard help rows for outline map (edit) and outline view (read-only).
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OUTLINE_VIEW_HELP = exports.OUTLINE_EDIT_HELP = exports.OUTLINE_MAP_HELP = void 0;
/** View-mode map navigation (edit directive, map focused, not label-editing). */
exports.OUTLINE_MAP_HELP = [
    { keys: '↑ / ↓', action: 'Move focus among visible items' },
    { keys: '← / →', action: 'Collapse / expand (or jump to parent / child)' },
    { keys: 'Alt+↑ / Alt+↓', action: 'Reorder among siblings (keeps children)' },
    { keys: 'Tab / Shift+Tab', action: 'Indent / outdent' },
    { keys: 'Alt+→ / Alt+←', action: 'Indent / outdent (same as Tab)' },
    { keys: '. or Space', action: 'Toggle fold on focused item' },
    { keys: 'e / F2', action: 'Edit label' },
    { keys: 'Enter', action: 'New sibling after focus' },
    { keys: 'Ctrl/⌘+Enter', action: 'New child under focus' },
    { keys: '0', action: 'Collapse all' },
    { keys: '1–9', action: 'Expand through presentation level (1–2 = tops)' },
    { keys: 'c / C', action: 'Collapse all / expand all' },
    { keys: 'x', action: 'Toggle checkbox' },
    { keys: 'Backspace', action: 'Delete empty item' },
    { keys: 's', action: 'Split label on ,,, into peer items' },
    { keys: '? or i', action: 'Toggle this help' },
    { keys: 'Esc', action: 'Exit present / keep work (persist)' },
];
/** Label edit field (map item editing). */
exports.OUTLINE_EDIT_HELP = [
    { keys: 'Enter', action: 'Commit label (also splits on ,,, )' },
    { keys: 'Shift+Enter', action: 'Newline in multi-line label box' },
    { keys: 'Esc', action: 'Cancel label edit' },
    { keys: '↑ / ↓ at ends', action: 'Commit and move to prev/next item' },
    { keys: ',,,', action: 'In label text: commit → slice into peer bullets' },
];
/** Read-only result-row outline view (session folds only). */
exports.OUTLINE_VIEW_HELP = [
    { keys: '↑ / ↓', action: 'Move focus among visible items' },
    { keys: '← / →', action: 'Collapse / expand in session (not saved)' },
    { keys: '. or Space', action: 'Toggle fold' },
    { keys: '0', action: 'Collapse all (session)' },
    { keys: '1–9', action: 'Expand through presentation level' },
    { keys: 'c / C', action: 'Collapse all / expand all' },
    { keys: '? or i', action: 'Toggle this help' },
    { keys: 'Click twistie', action: 'Fold one node (view only)' },
];
